import { Info } from "lucide-react";
import { useState } from "react";
import { Tooltip } from "../../../../components/Tooltip";

export function EnhancementOptions({ enhancements, onEnhancementsChange }) {
    const [localEnhancements, setLocalEnhancements] = useState(enhancements || {
        fixClipping: true,
        fixLoudness: true,
        fixStereoWidth: true,
        fixDynamicRange: true,
        fixTonalBalance: true
    });

    const currentEnhancements = enhancements || localEnhancements;

    const toggleEnhancement = (key) => {
        const updatedEnhancements = { ...currentEnhancements, [key]: !currentEnhancements[key] };
        if (!enhancements) {
            setLocalEnhancements(updatedEnhancements);
        }
        if (onEnhancementsChange) {
            onEnhancementsChange(updatedEnhancements);
        }
    };
    return (
        <div className="px-6 pb-4" data-tour="enhancement-settings">
            <div className="flex items-center justify-center gap-2 mb-3">
                <span className="text-theme_clr4 font-semibold">Enhancement options</span>
                <Tooltip
                    title="Enhancement Options"
                    text={`<ol style="margin:0;padding-left:1rem;line-height:1.35">
<li><strong>Fix Clipping:</strong> Reduce distortion from audio peaks that exceed the allowable limit.</li>
<li><strong>Fix Loudness:</strong> Normalize overall loudness to match industry targets for consistent playback.</li>
<li><strong>Fix Stereo Width:</strong> Improve stereo image and separation for a wider, clearer mix.</li>
<li><strong>Fix Dynamic Range Compression:</strong> Balance quiet and loud parts for a more polished, less fatiguing listening experience.</li>
<li><strong>Fix Tonal Balance:</strong> Correct frequency imbalances to better match your genre's expected tonal profile.</li>
</ol>`}
                    style={{ bg: "bg-white", text: "text-theme_clr4", width: "w-80" }}
                    position="right"
                >
                    <Info className="w-4 h-4 text-theme_clr2" />
                </Tooltip>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {Object.entries({
                    fixClipping: 'Fix Clipping',
                    fixLoudness: 'Fix Loudness',
                    fixStereoWidth: 'Fix Stereo Width',
                    fixDynamicRange: 'Fix Dynamic Range Compression',
                    fixTonalBalance: 'Fix Tonal Balance'
                }).map(([key, label]) => (
                    <div key={key} className="flex items-center justify-between border border-theme_clr1 rounded-full px-4 py-2">
                        <span className="text-theme_clr4 font-normal text-sm mr-2">{label}</span>
                        <button
                            onClick={() => toggleEnhancement(key)}
                            className={`w-12 h-6 rounded-full transition-colors relative ${currentEnhancements[key] ? 'bg-theme_clr4' : 'bg-gray-300'
                                }`}
                        >
                            <div className={`w-5 h-5 bg-white rounded-full absolute top-0.5 transition-transform ${currentEnhancements[key] ? 'translate-x-6' : 'translate-x-0.5'
                                }`}></div>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    )
}